import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { BannerLogo } from "../../components/BannerLogo";

const ActivateUser = () => {
    const { id } = useParams();
    const { user } = useAuth(); // Assuming NemuContext is used for user context
    const token = localStorage.getItem("token");
    const navigate = useNavigate();

    console.log("User:", user);

    if (!user || !token || user.role !== "admin") {
        navigate("/profile");
    }

    useEffect(() => {
        const activation = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/user/activateUser/${id}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });
                
                console.log("Response:", response);
            } catch (error) {
                console.error("Error activating user:", error);
            }
        }
        activation();
    }, [id]);
        
    
    return (
        <div className="grid grid-cols-2 w-screen h-svh bg-[#EAEAEA]">
            <BannerLogo />
            <div className="flex w-full h-svh justify-center items-center">
            <div className="flex flex-col fixed top-0 right-0 h-svh w-[50svw] px-[10%] py-[6%] justify-center items-center gap-[2rem]">
                <div className="flex w-full justify-start gap-4">
                <img src="/assets/Login/icon-good.svg" alt="good_Icon" />
                <h1 className="text-2xl text-nemu-green ">Usuario activado correctamente</h1>
                </div>
                <p className="text-base">A partir de ahora, el usuario podrá iniciar sesión y gestionar sus desarrollos.</p>
                <button className="flex w-full justify-center items-center px-[1.5rem] py-3 bg-[#282827] rounded-[8px]">
                    <span onClick={() => navigate("/profile")} className="text-white">Regresar al inicio</span>
                </button>
            </div>   
            </div>
        </div>
    );
}

export { ActivateUser };